/**
 * UserDashboard Presenter — 用户端接口调用封装
 *
 * MVP 架构中的 Presenter 层，负责：
 * 1. 封装所有用户端相关的 API 调用（postHttp）
 * 2. 将回调式 API 包装为 Promise，方便 async/await 使用
 * 3. 普通用户只能访问的接口（非管理员专属）
 *
 * 接口文档参考：根目录 接口文档.md
 * 路由前缀：
 *   - FXZ  = /fg-ai-center/fxzapi  （AI工具、公告）
 *   - NEWAPI = /fg-ai-center/newapi  （Token 用量）
 */

import { postHttp } from '../../utils/service';
import { FXZ_API_URI_PREFIX, NEWAPI_API_URI_PREFIX } from '../../utils/fxzApiService';

// ===================== AI 工具接口 =====================

/**
 * 查询 AI 工具列表（普通用户视角）
 * 接口文档 #7 — POST /fxzapi/agent/qry
 * ⚠️ 普通用户默认只返回 status=1 的启用中工具
 * @param {object} params - { agent_name?: string, agent_id?: string, agent_type?: string, status?: string }
 * @returns {Promise<{status: number, msg: string, agents: Array}>}
 */
export function getAgents(params) {
  return new Promise((resolve) => {
    postHttp(FXZ_API_URI_PREFIX, '/agent/qry', params || {}, resolve);
  });
}

// ===================== 公告接口 =====================

/**
 * 查询公告列表
 * 接口文档 #11 — POST /fxzapi/public_statement/qry
 * @returns {Promise<{status: number, msg: string, public_statements: Array}>}
 */
export function getAnnouncements() {
  return new Promise((resolve) => {
    postHttp(FXZ_API_URI_PREFIX, '/public_statement/qry', {}, resolve);
  });
}

// ===================== Token 用量接口 =====================

/**
 * 查询当前用户 Token 用量（今日/本周/本月）
 * 接口文档 #15 — POST /newapi/log/token_usage
 * @returns {Promise<{status: number, msg: string, data: {today: object, week: object, month: object}}>}
 */
export function getTokenUsage() {
  return new Promise((resolve) => {
    postHttp(NEWAPI_API_URI_PREFIX, '/log/token_usage', {}, resolve);
  });
}
